import SearchService from '../classes/SearchService';
const searchService = new SearchService();

// Calculate bike size, which child should buy after growing up
export default bike => {

    const maxBikeHeight = searchService.getHeightRange().max;

    if (Number(bike.wheel) === 16) {
        return 45;
    } else if (Number(bike.wheel) === 20) {

        if (bike.type === "premium") {
            return 52;
        } else {
            return 50;
        }
    } else {
        return Number(maxBikeHeight) - 1;
    }
}


// WEBPACK FOOTER //
// ./src/functions/getDueHeight.js